import { TodoRowConfig, HireFormTodoKey, OfferStageTodoKey } from './todoListTypes';

export const HIRE_FORM_ROWS: TodoRowConfig<HireFormTodoKey>[] = [
  { enumKey: HireFormTodoKey.Requested12HoursAgo, i18nKey: 'requested12HoursAgo' },
  { enumKey: HireFormTodoKey.Requested24HoursAgo, i18nKey: 'requested24HoursAgo' },
  { enumKey: HireFormTodoKey.Requested48HoursAgo, i18nKey: 'requested48HoursAgo' },
  { enumKey: HireFormTodoKey.Requested72HoursAgo, i18nKey: 'requested72HoursAgo' },
  { enumKey: HireFormTodoKey.Resubmission12HoursAgo, i18nKey: 'resubmission12HoursAgo' },
  { enumKey: HireFormTodoKey.Resubmission24HoursAgo, i18nKey: 'resubmission24HoursAgo' },
  { enumKey: HireFormTodoKey.Resubmission48HoursAgo, i18nKey: 'resubmission48HoursAgo' },
  { enumKey: HireFormTodoKey.Resubmission72HoursAgo, i18nKey: 'resubmission72HoursAgo' },
];

export const OFFER_STAGE_ROWS: TodoRowConfig<OfferStageTodoKey>[] = [
  { enumKey: OfferStageTodoKey.TwelveHoursAgo, i18nKey: 'twelveHoursAgo' },
  { enumKey: OfferStageTodoKey.TwentyFourHoursAgo, i18nKey: 'twentyFourHoursAgo' },
  { enumKey: OfferStageTodoKey.ThirtySixHoursAgo, i18nKey: 'thirtySixHoursAgo' },
  { enumKey: OfferStageTodoKey.FortyEightHoursAgo, i18nKey: 'fortyEightHoursAgo' },
];
